export const BlogSearch = () => {
  return `
    query BlogSearch($pagination: PaginationArg, $sort: [String], $status: PublicationStatus, $filters: BlogFiltersInput, $locale: I18NLocaleCode) {
  blogs(pagination: $pagination, sort: $sort, status: $status, filters: $filters, locale: $locale) {
    author {
      documentId
      avatar {
        caption
        name
        url
        publishedAt
        size
        updatedAt
        width
        documentId
      }
      name
    }
    slug
    short_description
    publishedAt
    title
    updatedAt
    priority
    media {
      name
      size
      url
      updatedAt
      width
      caption
    }
    documentId
    category {
      name
      slug
    }
      mobile_media {
      alternativeText
      caption
      url
    }
  }
}
  `;
};
